import Layout from '@/layout';

export default [
  {
    path: '/charts',
    name: 'Charts',
    redirect: '/charts/map',
    component: Layout,
    meta: {
      title: '数据中心',
      icon: 'icon-charts',
    },
    children: [
      {
        path: 'map',
        name: 'ChartsMap',
        component: () => import('@/views/charts/Map'),
        meta: {
          title: '地图数据',
        },
      },
      {
        path: 'resource',
        name: 'ChartsResource',
        component: () => import('@/views/charts/Resource'),
        meta: {
          title: '资源数据',
        },
        // hidden: true,
      },
      {
        path: 'detail',
        name: 'ChartsDetail',
        component: () => import('@/views/charts/Detail'),
        meta: {
          title: '作品详情',
          activePath: 'map',
        },
        hidden: true,
      },
      {
        path: 'resourceDetail',
        name: 'ChartsResourceDetail',
        component: () => import('@/views/charts/ResourceDetail'),
        meta: {
          title: '作品详情',
          activePath: 'resource',
        },
        hidden: true,
      },
    ],
  },
];
